import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
	setupExternalServices,
	setupExternalServicesWithUser,
} from "../AppUtils";

export const WithTracking = ({ children }) => {
	const user = useSelector((state) => state.auth);

	useEffect(() => {
		setupExternalServices();
	}, []);

	useEffect(() => {
		if (user?.user) {
			setupExternalServicesWithUser(user.user);
		}
	}, [user]);

	return <>{children}</>;
};
